import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c00750d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "input-wrapper" }
const _hoisted_3 = { class: "icon" }

import {
  ref,
  watch,
  PropType,
  computed,
  onUpdated,
  onRenderTracked,
  onBeforeMount,
  onActivated,
  onMounted
} from 'vue';
import InputNumber from 'primevue/inputnumber';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomNumberField',
  props: {
  modelValue: Number,
  id: String,
  placeholder: String,
  min: Number,
  max: Number,
  currency: String,
  mode: String
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const value = ref(props.modelValue);
const min = ref(props.min);
const max = ref(props.max);
const currency = ref(props.currency);
const mode = ref(props.mode);
const integeronly = computed(() => mode.value === 'integeronly');

watch(
  () => props.modelValue,
  (newValue) => {
    value.value = newValue;
  }
);

watch(value, (newValue) => {
  emit('update:modelValue', newValue);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.iconClass)
        }, null, 2)
      ]),
      (!currency.value && !integeronly.value)
        ? (_openBlock(), _createBlock(_unref(InputNumber), {
            key: 0,
            id: __props.id,
            placeholder: __props.placeholder,
            modelValue: value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
            inputId: "minmax",
            mode: "decimal",
            showButtons: "",
            min: min.value,
            max: max.value,
            pt: {
          root: {
            style: 'width: 100%;'
          }
        }
          }, null, 8, ["id", "placeholder", "modelValue", "min", "max"]))
        : _createCommentVNode("", true),
      (currency.value)
        ? (_openBlock(), _createBlock(_unref(InputNumber), {
            key: 1,
            id: __props.id,
            placeholder: __props.placeholder,
            modelValue: value.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
            inputId: "currency",
            mode: "currency",
            currency: currency.value,
            showButtons: "",
            pt: {
          root: {
            style: 'width: 100%;'
          }
        }
          }, null, 8, ["id", "placeholder", "modelValue", "currency"]))
        : _createCommentVNode("", true),
      (integeronly.value)
        ? (_openBlock(), _createBlock(_unref(InputNumber), {
            key: 2,
            id: __props.id,
            placeholder: __props.placeholder,
            modelValue: value.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value).value = $event)),
            inputId: "integeronly",
            showButtons: "",
            pt: {
          root: {
            style: 'width: 100%;'
          }
        }
          }, null, 8, ["id", "placeholder", "modelValue"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})